export const sanitizeCss = (css) =>
  css
    .replace(/@import\b[^;]*/gi, "/* @import removed */")
    .replace(/expression\s*\(/gi, "/* expression removed */(")
    .replace(/javascript\s*:/gi, "/* removed */")
    .replace(/-moz-binding\s*:/gi, "/* removed */:")
    .replace(/behavior\s*:/gi, "/* removed */:");
